export {
  isTabletDevice,
  getRealTimeTabletStatusDisplay,
  isOfflineTabletDisplay,
} from './deviceStatusDisplay'
